import { dateParts } from './math.js';
export function ageInMonths(birthDate, at) {
    const birth = dateParts(birthDate);
    const target = dateParts(at);
    let months = (target.year - birth.year) * 12 + target.month - birth.month;
    if (target.day < birth.day)
        months -= 1;
    return Math.max(0, months);
}
export function formatAge(months) {
    if (months >= 24)
        return `${Math.floor(months / 12)}년 ${months % 12}개월`;
    return `${months}개월`;
}
